<template>
  <div style="margin-left: 20">
  <div class="container">
  <div class="row">
		<table>
		<tr>
				<td>
					<h3 style="margin-top:10;margin-left: 50;">Register User</h3>
				</td>
		</tr>
		</table>
  </div>
  </div>

<form id="form_id" ref="form" @submit.prevent="processForm" >
<div class="container">
     <div class="row">
			<table class="table-horizontal" width="100%" height="20">
				<tbody>
	
					<tr>
						<td><strong>Email Id</strong></td>
						<td><input type="email" name="EmailId" v-model="EmailId" size="29" required></td>
						
					</tr>
					<tr>
						<td><strong>Role</strong></td>
						<td>
							<select v-model="role" required class="mumbai" >
							<option  selected>-Select-</option>
									<option value="user">User</option>
									<option value="restricted admin internal">Restricted Admin Internal</option>
									<option value="restricted admin external">Restricted Admin External</option>
									<option value="admin">Admin</option>
								</select>
						</td>
					</tr>
					<tr>
						<td><strong>Group Name</strong></td>
						<td >
								<select  class="select mumbai" v-model="group" style="width: 273px;margin-top:10px;" required>
									<option selected>-Select-</option>
									<option v-for="group in groups" v-bind:key="group.id"  v-bind:id="group" >{{group}}</option>
								</select>
							
						</td>
					</tr>
				</tbody>
			</table>
			</div>
	</div>
	<div class="container">
  <div class="row" >
		<button style="margin-top:20px;" type="submit" :disabled="isnotActive" v-on:click="addUser">Add user</button>
		&nbsp;&nbsp;&nbsp;&nbsp;
		<button style="margin-top:20px;" v-on:click="resetData()">Reset</button>

  </div>
	</div>
		</form>
  </div>
  
</template>

<script>
import axios from 'axios';
import store from '@/store';
export default {
name: 'HelloWorld',
props: {msg: String},
data () {
	return {
		Url:"reportData?",
		isnotActive:false,
		message:false,
		EmailId :'',
		role : '-Select-',
		jsonresponse:  [],
		groups : [],
		group : '-Select-',
}},
created: function(){
		this.resetData();
		this.groups =store.methods.getGroup();
	},
  methods: {
	validateReport()
	{
		var flag = true; var message = '';
		if (this.EmailId.length>0)
		{
			if(!(/@morningstar.com$/.test(this.mumbaianalystid)))
			{
				flag = false ; 
				message ="Please enter 'morningstar' emailid for Mumbai analyst";
			}
		}

		if(flag==false)
		{
			alert(message);
		}
		return flag;

	},
 addUser()
	{
		this.isnotActive=true;
			if(this.role !=='-Select-' && this.group !=='-Select-' ) {
				let	data = {"data": {"email": this.EmailId, "mobile number": "", "user role": this.role, "group name" :this.group}}
        
                
					
					axios.post(process.env.VUE_APP_BACKEND_API + `/CRS/registerUser`,data,{ withCredentials: true
					}		
					).then((response) => {
						if(response.status === 200)
                            alert("user registered for feedback app");
                            window.location.href = process.env.VUE_APP_UI + `RegisterUser`;
						}, (error) => {
						if(error.response.status === 406)
						{   
							alert("user already registered")
							window.location.href = process.env.VUE_APP_UI + `RegisterUser`;
						}
						else
						{
							alert("some error in registration")
							window.location.href = process.env.VUE_APP_UI + `RegisterUser`;
						}
					}); 
			}
			else {
				alert("Please Select Role and Group Name");
				this.isnotActive=false;
			}
						
	},
	resetData()
	{
		this.EmailId ='';
		this.isnotActive=false;
		this.role = '-Select-';
		this.group = '-Select-'
	}

  }
}
</script>
 


<style  scoped>
  
  * {
	font-family: "Univers", HelveticaNeue, "Helvetica Neue", Helvetica,
		Arial, sans-serif;
}


#commentdiv {
	cursor: pointer;
}

#mumbai_div {
  margin-left: 20px
}

#mumbai_title {
  text-align:left
}
.mumbai{
width: 273px;
margin-top:10px;
height: 25px;
}

</style>